<template>
  <div class="left-box2-main">
    <div class="statis-title">
      <img class="img1" src="@/assets/screen/bag.png" alt="" />
      <span>业务员邀请情况</span>
    </div>
    <div class="sales-volume" v-if="customerData">
      <div class="item1">
        业务员总人数<br />
        <span>{{customerData.yewuCou}}</span>
        <p v-if="ratioData">
          今日新增：{{ratioData.thisYear}}人
          <span class="font" :class="{'green': ratioData.yearPercent < 0}">{{Math.abs(ratioData.yearPercent)}}%</span>
          <img src="@/assets/screen/up1.png" alt="" v-if="ratioData.yearPercent > 0" />
          <img src="@/assets/screen/up.png" alt="" v-if="ratioData.yearPercent < 0" />
        </p>
      </div>
      <div class="item2">
        <p><span>大区经理</span>{{customerData.daquCou}}</p>
        <p><span>地区经理</span>{{customerData.diquCou}}</p>
        <p><span>县区经理</span>{{customerData.xianquCou}}</p>
      </div>
    </div>
    <echarts-vue :echart-data="echartData" echartName="echarts" height="130px" :isLine="false" />
  </div>

</template>

<script>
import echartsVue from './echarts.vue'
import { isToday, isYesterday, Subtr } from '@/utils/index'
export default {
  props: ['customerData'],
  components: { echartsVue },
  data() {
    return {
      echartsData: [],
      xData: [],
      ratioData: null
    }
  },
  watch: {
    customerData(newVal, oldVal) {
      this.getEcharts(newVal.yewulist)
      this.calcDate(newVal.yewulist)
      this.clacRatio(newVal.yewulist)
    }
  },
  methods: {
    clacRatio(data) {
      let thisD = data.find(item => isToday(item.startTime))
      let lastD = data.find(item => isYesterday(item.startTime))
      let obj = {
        thisYear: thisD.cou,
        lastYear: lastD.cou,
        yearPercent: lastD.cou ? (Subtr(thisD.cou, lastD.cou) / lastD.cou * 100).toFixed(2) : (thisD.cou ? 100 : 0),
      }
      this.ratioData = obj
    },
    calcDate(data) {
      let dateList = []
      data && data.forEach(item => {
        item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
      });
      dateList = data.map(item => item.date)
      this.xData = dateList
    },
    getEcharts(data) {
      this.echartsData = this.synthesisSeriesData(data, [
        { name: "当前", color: "#1596CD", key: "cou" },
        { name: "环比", color: "#EFDB1C", key: "huanBiCou" },
        { name: "同比", color: "#33AD47", key: "tongBiCou" },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 0 };
      } else if (chartType === 'bar') {
        itemStyle = { borderRadius: [30, 30, 0, 0] }
        param = { type: "bar", barWidth: "10%", barCategoryGap: "30%" };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    }
  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  }
}
</script>
<style lang="scss" scoped>
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}
@mixin fontColor($fonsSize, $color) {
  font-size: $fonsSize;
  color: $color;
}
.left-box2-main {
  .statis-title {
    display: flex;
    align-items: center;
    position: relative;
    span {
      @include fontColor(16px, #fff);
      padding: 0 10px 0 8px;
    }
    .img1 {
      @include wh(24px, 24px);
    }
    .hint {
      @include wh(13px, 13px);
      cursor: pointer;
    }
  }
  .sales-volume {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item1 {
      @include fontColor(18px, #fff);
      span {
        font-size: 48px;
      }
      p {
        margin: 0;
        @include fontColor(12px, #9292c1);
        .green {
          @include fontColor(12px, #5eff5a);
        }
        .font {
          font-size: 12px;
        }
        img {
          @include wh(14px, 14px);
          position: relative;
          top: 3px;
        }
      }
    }
    .item2 {
      @include fontColor(14px, #fff);
      p {
        margin: 0;
        padding-bottom: 8px;
        span {
          width: 84px;
          display: inline-block;
        }
      }
    }
  }
}
</style>
